"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const R = __importStar(require("ramda"));
const utils_1 = require("@8base/utils");
const table_schema_provider_1 = require("@8base-react/table-schema-provider");
const FormContext_1 = require("./FormContext");
const utils_2 = require("./utils");
/**
 * `Fieldset` passes relation table schema to the children fields.
 * @prop {string} [tableSchemaName] - The name of the 8base API table schema. Worked only if you provide schema by `SchemaContext`.
 */
const Fieldset = (_a) => {
    var { tableSchemaName } = _a, props = __rest(_a, ["tableSchemaName"]);
    const { appName } = react_1.useContext(FormContext_1.FormContext);
    const { tablesList } = react_1.useContext(table_schema_provider_1.TableSchemaContext);
    let tableSchema;
    if (tableSchemaName && tablesList) {
        tableSchema = utils_1.tablesListSelectors.getTableByName(tablesList, tableSchemaName, appName);
    }
    props = R.assoc('tableSchema', tableSchema, props);
    return react_1.default.createElement(FormContext_1.FormContext.Provider, { value: { tableSchema } }, utils_2.renderComponent(props));
};
exports.Fieldset = Fieldset;
//# sourceMappingURL=Fieldset.js.map